import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class GetOpeningHours extends Event {
    eventName = 'oms_getOpeningHours';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get opening hours
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let currentLocation = new LocalStorage.CurrentLocation(clientId).getData();
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.getOpeningHours;
        data.method = 'POST';
        data.data = {
            client_id: clientId,
            location_id: currentLocation,
            is_future_dates: 1
        };

        this.sendRequest(data, function (response) {
            if (response) {
                //add data to storage
                let openingHours = new LocalStorage.OpeningHours(currentLocation);
                openingHours.setData(response);

                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
    }
}

export default GetOpeningHours;